/// <amd-module name="typeahead/features/RedirectCubaPackageSearch" />
import {FormSubmittedMessage} from "typeahead/core/message/FormSubmittedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {ISuggestionData} from "typeahead/core/Suggestion";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export class RedirectCubaPackageSearch {

    private readonly applicableClientIds: string [] = ["Homepage", "AWSHomepage", "PackageLandingPage"];
    private readonly applicablePackageTypes: string [] = ["FH"];

    constructor() {
        TypeaheadMessage.subscribe(FormSubmittedMessage.getTopic(),
            (topic: string, message: FormSubmittedMessage) => {
                if (message.isFormValid() && this.isRedirectApplicable()) {
                    if (message.getEvent()) {
                        let redirectPath: string = this.getRedirectPath($(message.getEvent().currentTarget));
                        if (redirectPath) {
                            message.getEvent().preventDefault();
                            window.location.href = redirectPath;
                        }
                    }
                }
            });
    }

    private isRedirectApplicable(): boolean {
        let clientId: string = TypeaheadUtils.getClientId();
        let shortPackageType: string = TypeaheadUtils.getShortPackageType();
        return (this.applicableClientIds.indexOf(clientId) > -1 &&
            this.applicablePackageTypes.indexOf(shortPackageType) > -1);
    }

    private getRedirectPath($form: JQuery): string {
        let taJsonString: string = $form.find("input[data-gcw-field-type=destination]:visible").
            closest("div.autocomplete").find("input[data-gcw-storeable-name=gcw-destination-ta]").val();
        if (taJsonString) {
            let taJson: ISuggestionData = JSON.parse(taJsonString);
            if (taJson.redirectPath) {
                return window.location.protocol + "//" + window.location.host + taJson.redirectPath;
            }
        }
        return undefined;
    }
}
